import React, { Component } from 'react';
import PropTypes from 'prop-types';
import ParadigmaModal from "../../../components/ParadigmaModal"
import ParadigmaLabeledInput from "../../../components/ParadigmaLabeledInput";
import api from "../../../api";

class Notificacion extends Component {
    constructor(props) {
        super(props);
        this.state = {
            Nombre:'',
            title:'',
            notification : {
                body:'',
                title:'',
            },
            errors: [],
        };
    }

    static propTypes = {
        row: PropTypes.func,
        onSubmit: PropTypes.func,
        id: PropTypes.func,
    }

    resetForm() {
        this.setState({
            Nombre:'',
            notification : {
                body:'',
                title:'',
            },
            errors: [],
        });
    }

    getData() {
        return  this.state.notification;
    }

    setErrors(errors) {
        this.setState({
            errors: errors,
        });
    }

    onChangeField(field, value) {
        this.setState(prevState => {
            let errors = prevState.errors;
            if (errors) errors[field] = null;
            prevState.errors = errors;
            prevState[field] = value;
            return prevState;
        });
    }

    getError(field) {
        let errors = this.state.errors;
        if (errors) return errors[field];
        else return null;
    }

    modalVars() {    
        return {
            get: false,
            submitType: "POST",
            title: "Enviar Notificación",
            buttonTitle: "Enviar Notificación",
            danger: false,
            warning: true,
            buttonIcon: "fa fa fa-send-o fa-lg",
            successMessage: "Se ha enviado la notificación.",
            saveButton: true,
            saveButtonLabel: "Enviar",
            buttonClass: "btn-secondary",
            disabled: true,
            id: this.props.id,
        };   
    }

    render() {
        let vars = this.modalVars();
        let submitUrl = api.usuarios.notificacion;
        const fieldClassNames = ["ui-field-label-col", "ui-field-control-col"];
        return (
            <ParadigmaModal
                getUrl={null}
                submitUrl={submitUrl}
                submitType={vars.submitType}
                id={vars.id}
                className="ui-paradigma-modal ui-paradigma-modal-wide"
                onGotErrors={(errors) => this.setErrors(errors)}
                onSubmit={(e) => this.props.onSubmit(e)}
                onClose={() => this.resetForm()}
                onPreSubmit={() => this.getData()}

                title={vars.title}

                danger={vars.danger}
                buttonClass={vars.buttonClass}

                successMessage={vars.successMessage}
                missingIdMessage={"Debe seleccionar una fila."}
                saveButtonLabel={vars.saveButtonLabel}
                buttonTitle={vars.buttonTitle}
                buttonIcon={vars.buttonIcon}
                saveButton={vars.saveButton}
                closeButton={true}
            >
                <section className="ui-modal-section">
                    <p className="ui-section-label">Destinatario</p>
                    <div className="ui-form-grid">
                        <div className="ui-span-2">
                            <ParadigmaLabeledInput
                                disabled={true}
                                md={[12, 12]}
                                classNames={fieldClassNames}
                                label={"Usuario"}
                                value={this.props.row() ? this.props.row().apellido_nombre : ''}
                                error={() => this.getError('username')}
                            />
                        </div>
                    </div>
                </section>

                <section className="ui-modal-section">
                    <p className="ui-section-label">Notificación</p>
                    <div className="ui-form-grid">
                        <div className="ui-span-2">
                            <ParadigmaLabeledInput
                                md={[12, 12]}
                                classNames={fieldClassNames}
                                label={"Título"}
                                value={this.state.notification.title}
                                onChange={(e) => this.setState({
                                    notification: {
                                        title: e.target.value,
                                        body: this.state.notification.body,
                                    }
                                })}
                            />
                        </div>
                        <div className="ui-span-2">
                            <ParadigmaLabeledInput
                                md={[12, 12]}
                                classNames={fieldClassNames}
                                label={"Texto"}
                                type={"textarea"}
                                rows={7}
                                value={this.state.notification.body}
                                onChange={(e) => this.setState({
                                    notification: {
                                        title: this.state.notification.title,
                                        body: e.target.value,
                                    }
                                })}
                            />
                        </div>
                    </div>
                </section>
            </ParadigmaModal>
        );
    }
}

export default Notificacion;



// WEBPACK FOOTER //
// ./src/views/Usuarios/Usuarios/Notificacion.js